import withThemeProvider from "./with/withThemeProvider";
import withCompareDate from "./with/withCompareDate";
export { withThemeProvider, withCompareDate };


// WEBPACK FOOTER //
// ./src/hoc/index.js